import * as React from 'react';
import { EllipsisSpan, MxColumnType } from '@maxtropy/components';
import { parseOnDisplay } from '@/shared/components/FormulaInput';
import { getRange } from '@/shared/utils/utils';

export const getThirdColumns = (map: Map<string, string>): MxColumnType<any>[] => [
  {
    title: '虚拟点类型',
    dataIndex: 'hasProperty',
    ellipsis: { showTitle: true },
    render: (value: boolean) => <EllipsisSpan value={value ? '建模虚拟点' : '非建模虚拟点'} />,
  },
  {
    title: '是否可写',
    dataIndex: 'writable',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={v ? '是' : '否'} />,
  },
  {
    title: '公式',
    dataIndex: 'formula',
    ellipsis: { showTitle: true },
    render: (v: string) => <EllipsisSpan value={parseOnDisplay(v, map)} />,
  },
    {
      title: '数值合理区间',
      dataIndex: 'valueRange',
      ellipsis: { showTitle: true },
      render: (_: any, record) => (
        <EllipsisSpan value={getRange(record.parameters?.valueFloor, record.parameters?.valueCeiling)} />
      ),
    },
    {
      title: '云端增长值合理区间',
      dataIndex: 'cloudValueRange',
      ellipsis: { showTitle: true },
      render: (_: any, record) => (
        <EllipsisSpan value={getRange(record.parameters?.cloudValueFloor, record.parameters?.cloudValueCeiling)} />
      ),
    },
    {
      title: '云端异常数据过滤个数',
      dataIndex: 'cloudValueFilterCnt',
      ellipsis: { showTitle: true },
      render: (_: undefined, record) => {
        return <EllipsisSpan value={record.parameters.cloudValueFilterCnt} />;
      },
    },
  {
    title: '备注',
    dataIndex: 'remark',
    ellipsis: { showTitle: true },
    render: (value: string) => <EllipsisSpan value={value} />,
  },
];
